/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { HttpClient, RequestParams } from "./http-client";

export class OnlineLessons<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name GetScheduleList
   * @request GET:/OnlineLessons/GetSchedule
   * @secure
   */
  getScheduleList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/GetSchedule`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name GetLessonDetail
   * @request GET:/OnlineLessons/GetLesson/{lessonId}
   * @secure
   */
  getLessonDetail = (lessonId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/GetLesson/${lessonId}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name GetBookingList
   * @request GET:/OnlineLessons/GetBooking
   * @secure
   */
  getBookingList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/GetBooking`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name BookCreate
   * @request POST:/OnlineLessons/Book/{slotId}
   * @secure
   */
  bookCreate = (slotId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/Book/${slotId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name CancelCreate
   * @request POST:/OnlineLessons/Cancel/{lessonId}
   * @secure
   */
  cancelCreate = (lessonId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/Cancel/${lessonId}`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name GetJourneyList
   * @request GET:/OnlineLessons/GetJourney
   * @secure
   */
  getJourneyList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/GetJourney`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags OnlineLessons
   * @name VoteCreate
   * @request POST:/OnlineLessons/Vote/{optionId}
   * @secure
   */
  voteCreate = (optionId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/OnlineLessons/Vote/${optionId}`,
      method: "POST",
      secure: true,
      ...params,
    });
}
